import React from "react";
import {Card, Input, List, Skeleton} from "antd";
import {ShopOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {useStore} from "../../../hooks/useStore";
import {useObserver} from "mobx-react-lite";
import {HeaderText} from "../profileStyles";

export const CustomerInfoCard = ({userProfileInfo}) => {
    const {t} = useTranslation(["profilePage"]);
    const stores = useStore();

    return useObserver(() => {
        const companyInfo = [];

        const selectedSubCompanyId = stores.meStore.selectedSubCompanyId;
        const selectedSubCompany = userProfileInfo?.subcompanyInfos?.find(
            subCompany => subCompany._id === selectedSubCompanyId
        );

        const subCompany = selectedSubCompany;
        const cityCounty =
            subCompany?.city && subCompany?.county
                ? `${subCompany.city} / ${subCompany.county}`
                : subCompany?.city || subCompany?.county || "Belirlenmemiş";

        companyInfo.push({
            title: "İl/İlçe",
            value: cityCounty
        });

        // Adres bilgisi
        companyInfo.push({
            title: "Adres",
            value: subCompany?.address || "Belirlenmemiş"
        });

        // Email bilgisi
        companyInfo.push({
            title: "E-mail",
            value: subCompany?.authorizedEmail || "Belirlenmemiş"
        });

        // Telefon bilgisi
        companyInfo.push({
            title: "Telefon",
            value: userProfileInfo.phone || "Belirlenmemiş"
        });

        return (
            <Card title="Alt Firma Bilgileri">
                <List
                    dataSource={companyInfo}
                    renderItem={row => (
                        <List.Item style={styles.listItem}>
                            <Skeleton loading={false} active>
                                <List.Item.Meta
                                    description={row.title}
                                    style={styles.listItemMeta}
                                />
                                {/* <div
                                    data-testid="companyInfo"
                                    data-testvalue={row.title}
                                    style={styles.listItemValue}
                                >
                                    {row.value}
                                </div> */}
                                <Input value={row.value} disabled className="user-info-input" />
                            </Skeleton>
                        </List.Item>
                    )}
                    style={styles.list}
                />
            </Card>
        );
    });
};

const styles = {
    list: {
        backgroundColor: "#fff",
        borderRadius: "4px"
    },
    listItem: {
        padding: "10px 0",
        borderBottom: "1px solid #f0f0f0"
    },
    listItemMeta: {
        padding: "10px 20px",
        minWidth: "150px",
        fontWeight: "500",
        color: "#666"
    },
    listItemValue: {
        padding: "10px 20px",
        flex: 1,
        fontWeight: "400",
        color: "#333"
    }
};
